import config from "../../config";
export const apiUrl = config.api_url;

export const ticketService = {
    GET_ALL: per_page => `${apiUrl}tickets?per_page=${100}`,
};
